import { log } from 'log';
import { usePushSubscription } from 'server';
import { MutableRefObject } from 'react';

import * as Types from '../types';
import * as constants from 'js/components/tagTypes/Geofencing/constants';

export const useOnIpChange = ({
    sdk,
    nextTime,
    triggerGeolocation,
    setTransactionID,
    setNextTime,
    triggerTimestampRef
}: {
    sdk: Types.GeofencingSdkInstance | null;
    nextTime: number;
    triggerGeolocation: Types.TriggerGeolocationCallback;
    setTransactionID: (transactionID: string | null) => void;
    setNextTime: (nextTime: number) => void;
    triggerTimestampRef: MutableRefObject<number | null>;
}) => {
    usePushSubscription(31133, () => async (pushMessage) => {
        if (!sdk || !nextTime) {
            return;
        }

        const { action } = pushMessage.data;
        const actionType = Object.keys(action);

        if (actionType.includes('actionIpChangedInfo')) {
            log('gcInfo', { event: 'actionIpChangedInfo' });

            // unset current timeout
            triggerTimestampRef.current = null;
            setTransactionID(null);
            setNextTime(0);

            await triggerGeolocation({
                reason: constants.GEOLOCATION_REASON.IP_CHANGE_CHECK
            });
        }
    }, [
        sdk,
        nextTime,
        triggerGeolocation,
        setTransactionID,
        setNextTime,
        triggerTimestampRef
    ]);
};
